module.exports = __webpack_public_path__ + "img/leaf-right-blurry.c86c9737.png";